import React from "react";
import Label from "../atoms/Label";
import Image from "../atoms/Image";
import Video from "../atoms/Video";
import { markdownToJSX } from "../../util/transforms";

export default ({ heroAsH1=true, image, video, label, title, classes }) => {
    //const HeadingTag = `h${ heroAsH1 ? 1 : 2 }`
    const HeadingTag = heroAsH1 ? "h1" : "div"
    return (
        <section className={"o-hero" + (classes ? (" " + classes) : "") }>
            { (label || title) &&
            <div className="o-hero__content u-center-text { $classes }">
                <HeadingTag className="o-hero__title">
                <Label text={ label } isSpan/>
                { (title) && <span>{ markdownToJSX(title) }</span> }
                </HeadingTag>
            </div>
            }
            { (image && !video) &&
                <Image className="o-hero__media" image={ image } loading="eager"/>
            }
            { (video?.file?.url) &&
            <Video
                src={ video.file.url }
                className="o-hero__media"
                autoPlay
                playsInline
                loop
                muted
                poster={ image ? image.file.url : null }
            />
            }
        </section>
    );
}
